import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["scrollContainer", "sentinel", "loader"]
  static values = {
    url: String,
    listType: String,
    offset: { type: Number, default: 0 },
    total: { type: Number, default: 0 },
    perPage: { type: Number, default: 3 }
  }

  connect() {
    if (this.#hasMoreItems && this.hasSentinelTarget) {
      this.#setupObserver()
    }
  }

  disconnect() {
    this.observer?.disconnect()
  }

  async loadMore() {
    if (this.loading || !this.#hasMoreItems) return

    this.loading = true
    this.#showLoader()

    try {
      const url = new URL(this.urlValue, window.location.origin)
      url.searchParams.set("list_type", this.listTypeValue)
      url.searchParams.set("offset", this.offsetValue)

      const response = await fetch(url, {
        headers: { "Accept": "text/vnd.turbo-stream.html" }
      })

      if (response.ok) {
        const html = await response.text()
        if (html.trim()) {
          Turbo.renderStreamMessage(html)
          this.offsetValue += this.perPageValue
        }
      }
    } finally {
      this.loading = false
      this.#hideLoader()
      if (!this.#hasMoreItems) this.#hideSentinel()
    }
  }

  // Private

  #setupObserver() {
    const root = this.hasScrollContainerTarget ? this.scrollContainerTarget : null

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.loading && this.#hasMoreItems) {
            this.loadMore()
          }
        })
      },
      { root, rootMargin: "50px", threshold: 0.1 }
    )

    this.observer.observe(this.sentinelTarget)
  }

  get #hasMoreItems() {
    return this.offsetValue < this.totalValue
  }

  #showLoader() {
    this.loaderTarget?.classList.remove("hidden")
  }

  #hideLoader() {
    this.loaderTarget?.classList.add("hidden")
  }

  #hideSentinel() {
    this.sentinelTarget?.classList.add("hidden")
    this.loaderTarget?.classList.add("hidden")
  }
}
